export const formatarCelular = (number) => {
  try {
    let value = number.replace(/\D/g, "");
    value = value.replace(/^0/, "");
    if (value.length > 10) {
      // Format: (11) 99999-9999
      value = value.replace(/^(\d{2})(\d{5})(\d{4}).*/, "($1) $2-$3");
    } else if (value.length === 7) {
      // Format: (11) 3456-7
      value = value.replace(/^(\d{2})(\d{4})(\d{1})/, "($1) $2-$3");
    } else if (value.length > 6) {
      // Format: (11) 9999-9999
      value = value.replace(/^(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
    } else if (value.length > 2) {
      // Format: (11) 9999
      value = value.replace(/^(\d{2})(\d{0,4})/, "($1) $2");
    } else if (value.length > 0) {
      // Format: (11
      value = value.replace(/^(\d*)/, "($1");
    }

    return value;
  } catch (error) {
    console.error(error);
    return number;
  }
};
